import i18n from '~/locales/i18n';

i18n.addResourceBundle('ar', 'app', {
  noSubscriptionsFound: 'ليس لديك أي اشتراكات ',
  reSubscribe: 'اعادة الدفع',
  renewalDate: 'تاريخ التجديد',
  endDate: 'تاريخ الانتهاء',
  reactivate: 'إعادة التفعيل',
  expiringSoon: 'سينتهي قريباً',
  autoRenewal: 'سيتم التجديد تلقائياً كل شهر',
  autoRenewalCanceled:
    'تم إلغاء التجديد التلقائي. ستستمر في الاستفادة من مزايا الباقة حتى تاريخ الانتهاء',
  cancelSubscription: 'الغاء الاشتراك',
  cancelSubscriptionConfirm: 'هل انت متأكد انك تريد الغاء  اشتراك ؟',
  cancelSubscriptionNote:
    'إذا قمت بالالغاء الآن، سيظل اشتراكك سارياً حتى {{date}}.',
  noValue: 'لم أجد فائدة كافية من الاشتراك',
  toExpensive: 'الاشتراك غالي جدًا بالنسبة لي',
  hardToUse: 'واجهت صعوبة في استخدام المزايا',
  noNeedAnymore: 'لم أعد أحتاج الخدمة حاليًا',
  anotherReason: 'سبب أخر',
  requiredReason: 'برجاء اختيار سبب',
  explainIssue: 'اشرح المشكلة',
  whyCanceling: 'لماذا تريد الغاء الاشتراك ؟',
  requiredComment: 'يجب شرح سبب المشكلة',
});
